<template>
    <div>
        <div class="app-title">
            <em-view-title key="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <app-content>

        </app-content>
    </div>
</template>

<script>
import EmCommonApi from "@/mixin/em/common/api";
import emCommonListMixin from "@/mixin/em/common/list";
import AppContent from "@/components/echarts-part/stuff/AppContent";

export default {
    name: "ScheduleDetailList",
    components: {AppContent},
    mixins: [EmCommonApi, emCommonListMixin],
}
</script>

<style scoped>

</style>